import React from "react";

const TrophySvg = () => (
  <svg
    viewBox="0 0 87 95"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <g clipPath="url(#prefix__clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.938 91.11h14.448V75.456H35.938V91.11z"
        fill="#FAD633"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.857 18.187v31.306c0 17.289 14.016 31.304 31.306 31.304s31.306-14.015 31.306-31.304V18.187H11.857z"
        fill="#FAD633"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.857 18.187v31.306c0 17.289 14.016 31.304 31.306 31.304s31.306-14.015 31.306-31.304V18.187H11.857z"
        fill="#FAD633"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.812 72.649a17.796 17.796 0 0 0 6.175-13.497c0-9.846-7.983-17.83-17.83-17.83-7.388 0-13.725 4.491-16.43 10.891a22.339 22.339 0 0 1 3.219-12.935l2.529 1.896v-5.287c4.107-4.546 10.049-7.403 16.66-7.403 12.393 0 22.443 10.048 22.443 22.443 0 10.434-7.121 19.206-16.766 21.722zM42.157 76.985c-9.85 0-17.831-7.984-17.831-17.833 0-2.461.499-4.806 1.401-6.939.666 11.797 10.441 21.16 22.408 21.16a22.47 22.47 0 0 0 5.677-.724 17.762 17.762 0 0 1-11.655 4.336z"
        fill="#F2B229"
      />
      <path
        d="M48.135 73.373c-11.967 0-21.742-9.363-22.408-21.16 2.705-6.4 9.042-10.891 16.43-10.891 9.847 0 17.83 7.984 17.83 17.83a17.796 17.796 0 0 1-6.175 13.497 22.47 22.47 0 0 1-5.677.724z"
        fill="#EC952D"
      />
      <path
        d="M0 44.971c0 7.777 6.303 14.082 14.08 14.082v-5.128a8.952 8.952 0 0 1-8.955-8.954 8.954 8.954 0 0 1 8.955-8.954v-5.125C6.303 30.892 0 37.195 0 44.971z"
        fill="#FAD633"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.326 44.971c0-7.776-6.303-14.079-14.081-14.079v5.125a8.954 8.954 0 0 1 8.955 8.954 8.952 8.952 0 0 1-8.955 8.954v5.128c7.778 0 14.081-6.305 14.081-14.082z"
        fill="#FAD633"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.424 25.41h-4.955v-7.223H42.452c.135-.821.205-1.662.205-2.521 0-1.641-.256-3.221-.73-4.704h37.497V25.41z"
        fill="#FAD532"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.469 25.41H39.191a15.36 15.36 0 0 0 3.261-7.223h32.017v7.223z"
        fill="#F2B229"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.857 25.41H6.903V10.962h5.628a15.423 15.423 0 0 0-.73 4.704c0 .859.07 1.7.205 2.521h-.149v7.223z"
        fill="#FAD532"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.268 25.41h-3.411v-7.223h.149a15.362 15.362 0 0 0 3.262 7.223z"
        fill="#F2B229"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.938 91.11h14.448v-3.334H35.938v3.334z"
        fill="#F2B229"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.083 95H30.242v-7.224h5.696v3.334h14.449v-3.334h5.696V95z"
        fill="#FAD532"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.657 15.666c0 8.52-6.907 15.427-15.427 15.427s-15.429-6.907-15.429-15.427C11.801 7.144 18.71.237 27.23.237s15.427 6.907 15.427 15.429z"
        fill="#4CBABE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.475 41.174l-5.5-4.124-5.214 4.124v-17.6h10.714v17.6z"
        fill="#4CBABE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.475 24.713v-1.139H20.761v1.138a9.868 9.868 0 0 1-4.521-8.3c0-5.454 4.423-9.877 9.879-9.877 5.454 0 9.876 4.423 9.876 9.877 0 3.481-1.8 6.541-4.52 8.301z"
        fill="#21969F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.119 26.29a9.834 9.834 0 0 1-5.358-1.578v-1.138h10.714v1.139a9.829 9.829 0 0 1-5.356 1.577z"
        fill="#21969F"
      />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path fill="#fff" d="M0 0h87v95H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default TrophySvg;
